<section
  *ngIf="data?.message"
  [class]="
    data?.error
      ? 'bg-error/10 border-error rounded border-l-4 text-error mb-4 p-3'
      : 'bg-success/10 border-success rounded border-l-4 text-success mb-4 p-3'
  "
  role="alert"
>
  <p class="text-sm">{{ data?.message }}</p>
</section>
